module.exports = __webpack_public_path__ + "images/feature/0717_cal_rp_1-9daeda63fc17175fbb25beb9e8104e1a.jpg";